<template>
	<nta-list-page
		:title="symbolsStore.GUILabel('fe4caf08-e069-4164-a5a2-5ed34fac2d48')"
		:subtitle="subtitle"
		:items="instanceDataspacesStore.dataspaces"
	>
		<template #actions>
			<v-btn
				v-if="domainStore.hasAccessRights(UserRole.Editor)"
				variant="tonal"
				color="success"
				min-width="6em"
				@click="newDataspace"
			>
				{{
					symbolsStore.GUILabel("59c65cfa-cd8d-47e2-ab59-003330041c4b", {
						label: symbolsStore.GUILabel("1fa57246-ae3e-4cbe-b38d-da224bedc183"),
					})
				}}
			</v-btn>
		</template>
		<template #default="{ item }">
			<v-list-item :key="item.id">
				<DataspaceCard :dataspace="item" />
			</v-list-item>
		</template>
	</nta-list-page>
	<DataspaceEditModal
		:show="editDataspaceModal.show"
		mode="create"
		@done="() => (editDataspaceModal.show = false)"
		@cancel="() => (editDataspaceModal.show = false)"
	/>
	<Members v-if="!displayResponsive && domainStore.isAdmin" />
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useDomainStore } from "../../../store/domain";
import { useInstanceDataspacesStore } from "../../../store/i-dataspace";
import { useSymbolsStore } from "../../../store/symbols";

import Members from "../../../components/Members.vue";
import DataspaceCard from "../components/DataspaceCard.vue";
import DataspaceEditModal from "../components/DataspaceEditModal.vue";
import { UserRole } from "@lr-notitia/notitia-operator/schemas";
import { useResponsiveLayout } from "@lr-notitia/notitia-ui";

const domainStore = useDomainStore();
const instanceDataspacesStore = useInstanceDataspacesStore();
const symbolsStore = useSymbolsStore();

const { displayResponsive } = useResponsiveLayout();

const subtitle = computed(() => {
	return symbolsStore.GUILabel("9b7de21d-6bff-4bc3-86c6-2bd655549345", {
		label: domainStore.domain.name,
		count: String(instanceDataspacesStore.dataspaces?.length ?? 0),
		type:
			instanceDataspacesStore.dataspaces?.length == 1
				? symbolsStore.GUILabel("1fa57246-ae3e-4cbe-b38d-da224bedc183")
				: symbolsStore.GUILabel("fe4caf08-e069-4164-a5a2-5ed34fac2d48"),
	});
});
const editDataspaceModal = ref({ show: false });

function newDataspace() {
	editDataspaceModal.value.show = true;
}
</script>
